import { render, staticRenderFns } from "./lp-category-select.vue?vue&type=template&id=d4374d12&"
import script from "./lp-category-select.vue?vue&type=script&lang=js&"
export * from "./lp-category-select.vue?vue&type=script&lang=js&"
import style0 from "./lp-category-select.vue?vue&type=style&index=0&id=d4374d12&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports